import React from 'react';

interface IProps {
    /** Controls whether to show children by default */
    startOpen: boolean;
    children: any;
    /** Custom toggle component. Recieves onClick, and open as props */
    Toggle: any | JSX.Element | React.FC;
}

const CollapsibleArea: React.FC<IProps> = (props: IProps): any => {
    const { startOpen, Toggle } = props;
    const [open, setOpen] = React.useState(startOpen as boolean);

    const toggleOpen = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
    }

    return (
        <React.Fragment>
            <Toggle onClick={toggleOpen} open={open} />
            {
                open 
                ?
                <React.Fragment>
                    {props.children}
                </React.Fragment>
                :null
            }
        </React.Fragment>
    );
}

CollapsibleArea.defaultProps = {
    startOpen: false,
    Toggle: null
}

export default CollapsibleArea;